:host {
  @apply m-0 block;
}

::slotted(pk-accordion-item:not(:last-child)) {
  @apply mb-m;
}
